import React, { useState, useEffect } from 'react';
import PrescriptionModalMobile from './prescriptionModalMobile';
import PrescriptionModalWeb from './prescriptionModalWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const PrescriptionModalRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  if (width === 0) {
    return null;
  }

  return width < MOBILE_BREAKPOINT ? (
    <PrescriptionModalMobile {...props} />
  ) : (
    <PrescriptionModalWeb {...props} />
  );
};

export default PrescriptionModalRouter;
